<template>
  <div class="right_col" role="main">
    <div class="">
      <div class="page-title">
        <div class="title_left">
          <h3>
            {{ title }}
            <span v-if="isConfirmView"
              >- {{ $t('orderPage.inputConfirmation') }}</span
            >
          </h3>
        </div>
      </div>
      <div class="clearfix"></div>
      <div class="row">
        <div class="col-md-12 col-sm-12 col-xs-12">
          <div class="x_panel">
            <div class="x_content">
              <alert
                :title="title"
                :success-message="$t('common.isSuccess')"
                :error-message="$t('common.isFailure')"
                :alerts="alerts"
                :errors="errors"
                :display="wasTheRequestSuccessful"
                @closeAlert="closeAlert"
              />

              <div class="form-horizontal form-label-left">
                <div class="form-group">
                  <label
                    class="control-label col-md-3 col-sm-3 col-xs-12"
                    for="email"
                  >
                    {{ $t('accountManagementPage.userId') }}：
                    <span class="required">*</span>
                  </label>
                  <div class="col-md-6 col-sm-6 col-xs-12">
                    <input
                      id="email"
                      v-model="email"
                      v-validate="ValidRules.userId"
                      :disabled="isConfirmView"
                      :data-vv-as="$t('accountManagementPage.userId')"
                      :placeholder="$t('accountManagementPage.emailAddress')"
                      type="text"
                      name="email"
                      required="required"
                      class="form-control"
                      autocomplete="off"
                    />
                    <div
                      v-show="validator.has('email')"
                      class="alert alert-danger"
                      role="validater"
                    >
                      <ul>
                        <li
                          v-for="(message, index) in validator.collect('email')"
                          :key="index"
                        >
                          {{ message }}
                        </li>
                      </ul>
                    </div>
                  </div>
                </div>
                <div class="form-group">
                  <label
                    class="control-label col-md-3 col-sm-3 col-xs-12"
                    for="password"
                  >
                    {{ $t('accountManagementPage.password') }}：
                    <span v-show="!isEdit" class="required">*</span>
                  </label>
                  <div class="col-md-6 col-sm-6 col-xs-12">
                    <input
                      id="password"
                      ref="password"
                      v-model="password"
                      v-validate="getPasswordValidRule()"
                      :disabled="isConfirmView"
                      :data-vv-as="$t('accountManagementPage.password')"
                      :placeholder="$t('accountManagementPage.password')"
                      type="password"
                      name="password"
                      class="form-control"
                      autocomplete="off"
                    />
                    <div
                      v-show="validator.has('password')"
                      class="alert alert-danger"
                      role="validater"
                    >
                      <ul>
                        <li
                          v-for="(message, index) in validator.collect(
                            'password'
                          )"
                          :key="index"
                        >
                          {{ message }}
                        </li>
                      </ul>
                    </div>
                  </div>
                </div>
                <div class="form-group">
                  <label
                    class="control-label col-md-3 col-sm-3 col-xs-12"
                    for="password-confirmation"
                  >
                    {{ $t('accountManagementPage.passwordConfirmation') }}：
                    <span v-show="!isEdit" class="required">*</span>
                  </label>
                  <div class="col-md-6 col-sm-6 col-xs-12">
                    <input
                      id="password-confirmation"
                      ref="password-confirmation"
                      v-validate="getPasswordConfirmedValidRule()"
                      :disabled="isConfirmView"
                      :data-vv-as="
                        $t('accountManagementPage.passwordConfirmation')
                      "
                      :placeholder="
                        $t('accountManagementPage.passwordConfirmation')
                      "
                      type="password"
                      name="password-confirmation"
                      class="form-control"
                    />
                    <div
                      v-show="validator.has('password-confirmation')"
                      class="alert alert-danger"
                      role="validater"
                    >
                      <ul>
                        <li
                          v-for="(message, index) in validator.collect(
                            'password-confirmation'
                          )"
                          :key="index"
                        >
                          {{ message }}
                        </li>
                      </ul>
                    </div>
                  </div>
                </div>
                <div class="form-group">
                  <label
                    class="control-label col-md-3 col-sm-3 col-xs-12"
                    for="name"
                  >
                    {{ $t('accountManagementPage.name') }}：
                    <span class="required">*</span>
                  </label>
                  <div class="col-md-6 col-sm-6 col-xs-12">
                    <input
                      id="name"
                      v-model="name"
                      v-validate="ValidRules.name"
                      :disabled="isConfirmView"
                      :data-vv-as="$t('accountManagementPage.name')"
                      :placeholder="$t('accountManagementPage.name')"
                      type="text"
                      name="name"
                      required="required"
                      class="form-control"
                    />
                    <div
                      v-show="validator.has('name')"
                      class="alert alert-danger"
                      role="validater"
                    >
                      <ul>
                        <li
                          v-for="(message, index) in validator.collect('name')"
                          :key="index"
                        >
                          {{ message }}
                        </li>
                      </ul>
                    </div>
                  </div>
                </div>
                <div class="form-group">
                  <label class="control-label col-md-3 col-sm-3 col-xs-12">
                    {{ $t('accountManagementPage.authority') }}：
                    <span class="required">*</span></label
                  >
                  <div class="col-md-5 col-sm-5 col-xs-12">
                    <textarea
                      id="authority"
                      v-model="inputValues"
                      v-validate="ValidRules.authority"
                      :data-vv-as="$t('accountManagementPage.authority')"
                      name="authority"
                      required="required"
                      class="form-control"
                      style="height: 100px"
                      readonly
                    >
                    </textarea>
                    <div
                      v-show="validator.has('authority')"
                      class="alert alert-danger"
                      role="validater"
                    >
                      <ul>
                        <li
                          v-for="(message, index) in validator.collect(
                            'authority'
                          )"
                          :key="index"
                        >
                          {{ message }}
                        </li>
                      </ul>
                    </div>
                  </div>
                  <div class="col-md-3 col-sm-3 col-xs-12">
                    <button
                      id="authority-btn"
                      :disabled="isConfirmView"
                      @click="showModal = true"
                      class="btn btn-success"
                    >
                      {{ $t('common.add') }}
                    </button>
                  </div>
                  <modal
                    v-if="showModal"
                    :authority-params="authorityParams"
                    @close="showModal = false"
                    @authorityInput="authorityInput"
                  ></modal>
                </div>
                <div class="ln_solid"></div>
                <div class="form-group">
                  <div class="col-md-6 col-sm-6 col-xs-12 col-md-offset-3">
                    <button @click="back" class="btn btn-default">
                      {{ $t('common.back') }}
                    </button>
                    <button
                      v-if="!isConfirmView"
                      @click="confirm"
                      class="btn btn-success"
                    >
                      {{ $t('common.inputComplete') }}
                    </button>
                    <button v-else @click="submit" class="btn btn-success">
                      {{ $t('orderPage.registration') }}
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import Modal from '@/components/common/modal/UserAuthorityRegistModal'
import Alert from '@/components/common/alert/Alert'
import { mapGetters } from 'vuex'
import UserRequest from '@/http/UserRequest'
import ValidRules from '@/validator/UserRegisterRules'
export default {
  components: {
    Modal,
    Alert,
  },
  data() {
    return {
      id: '',
      name: '',
      email: '',
      password: '',
      comfirmPassword: '',
      authorities: [],
      isEdit: false, // 編集画面フラグ true=編集画面 false=登録画面
      isConfirmView: false, // 確認画面フラグ true=確認
      title: this.$t('accountManagementPage.userRegistration'),
      errors: null,
      alerts: '',
      wasTheRequestSuccessful: false,
      showModal: false,
      inputValues: '',
      authorityParams: [
        {
          viewId: 1,
          viewName: this.$t('subMenu.userManagement'),
          authority: 0,
        },
        {
          viewId: 2,
          viewName: this.$t('subMenu.itemInformation'),
          authority: 0,
        },
        {
          viewId: 3,
          viewName: this.$t('subMenu.itemImageUpload'),
          authority: 0,
        },
        {
          viewId: 4,
          viewName: this.$t('subMenu.category'),
          authority: 0,
        },
        {
          viewId: 5,
          viewName: this.$t('subMenu.menu'),
          authority: 0,
        },
        {
          viewId: 6,
          viewName: this.$t('subMenu.price'),
          authority: 0,
        },
        {
          viewId: 7,
          viewName: this.$t('subMenu.recommendOnOrder'),
          authority: 0,
        },
        {
          viewId: 8,
          viewName: this.$t('subMenu.timedRecommend'),
          authority: 0,
        },
        {
          viewId: 9,
          viewName: this.$t('subMenu.eventList'),
          authority: 0,
        },
        {
          viewId: 10,
          viewName: this.$t('accountManagementPage.ShopWholeConfig'),
          authority: 0,
        },
        {
          viewId: 11,
          viewName: this.$t('subMenu.shopList'),
          authority: 0,
        },
        {
          viewId: 12,
          viewName:
            process.env.VUE_APP_LANG === 'ja'
              ? this.$t('subMenu.sumahoDeBikkurapon-jp')
              : this.$t('subMenu.sumahoDeBikkurapon'),
          authority: 0,
        },
        {
          viewId: 13,
          viewName: this.$t('subMenu.searchConfig'),
          authority: 0,
        },
        {
          viewId: 14,
          viewName: this.$t('subMenu.groupConfig'),
          authority: 0,
        },
      ],
      ValidRules: ValidRules,
    }
  },
  computed: {
    ...mapGetters({
      getUserById: 'user/getUserById',
    }),
  },
  mounted() {
    if (this.$route.name === 'userformEdit') {
      this.getStoreData(this.$route.params.id)
      this.isEdit = true
      this.title = this.$t('accountManagementPage.editUser')
    }
  },
  methods: {
    // パスワードのバリデーションルールを取得する
    getPasswordValidRule: function() {
      return this.isEdit ? ValidRules.password.edit : ValidRules.password.create
    },
    // パスワード(確認)のバリデーションルールを取得する
    getPasswordConfirmedValidRule: function() {
      return this.isEdit
        ? ValidRules.passwordConfirmation.edit
        : ValidRules.passwordConfirmation.create
    },
    authorityInput: function(authorityParams) {
      this.authorityParams = authorityParams.map((authorityParam) => {
        return {
          ...authorityParam,
          authority: authorityParam.authority ? 1 : 0,
        }
      })
      this.inputValues = this.authorityParams
        .filter((authorityParam) => authorityParam.authority === 1)
        .map((authorityParam) => authorityParam.viewName)
        .join(', ')

      this.showModal = false
    },
    getStoreData: function(id) {
      const user = this.getUserById(id)
      try {
        this.id = user.id
        this.name = user.name
        this.email = user.email
        this.authorities = user.authorities
        this.authorities.forEach((item) => {
          let index = this.authorityParams.findIndex(
            (auth) => auth.viewId === item.viewId
          )
          this.authorityParams[index].authority = item.authority
          this.inputValues += item.viewName + ', '
        })
      } catch {
        console.log('faild')
      }
    },
    confirm: function() {
      this.$validator.validate().then((result) => {
        if (result) {
          this.isConfirmView = true
        }
      })
    },
    back: function() {
      if (this.isConfirmView) {
        this.isConfirmView = false
      } else {
        this.$router.go(-1)
      }
    },
    submit: function() {
      const request = new UserRequest()
      const inputArray = this.inputValues.split(', ')
      inputArray.pop()
      const authorities = this.authorityParams.filter(
        (authorityParam) => authorityParam.authority === 1
      )

      const params = {
        name: this.name,
        email: this.email,
        password: this.password,
        authorities: authorities,
      }
      if (this.isEdit) {
        if (params.password === '') {
          params.password = null
        }
        // 更新
        request
          .update(this.id, params)
          .then(() => {
            this.$router.push({
              name: 'user',
              params: { succeeded: true, title: this.title },
            })
          })
          .catch((err) => {
            this.errors =
              typeof err.response.data === 'object'
                ? [err.response.data]
                : err.response.data
            this.alerts = 'error'
            this.wasTheRequestSuccessful = true
            this.isConfirmView = false
            console.log(err.response)
          })
      } else {
        // 新規登録
        request
          .insert(params)
          .then(() => {
            this.$router.push({
              name: 'user',
              params: { succeeded: true, title: this.title },
            })
          })
          .catch((err) => {
            this.errors =
              typeof err.response.data === 'object'
                ? [err.response.data]
                : err.response.data
            this.alerts = 'error'
            this.wasTheRequestSuccessful = true
            this.isConfirmView = false
            console.log(err.response)
          })
      }
    },
    closeAlert: function() {
      this.wasTheRequestSuccessful = false
    },
  },
}
</script>
